
import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../Layout/PrivateLayout';
import * as rsuite from 'rsuite';
import { BiXCircle } from "react-icons/bi";




const AccessDenied = () => {


    useEffect(() => {
        document.title = "عدم دسترسی ";
    }, [])



    return (

        <Layout key="عدم دسترسی">
            <rsuite.Row>
                <rsuite.Col xs={24} className="text-center mt-20vh Font17">
                    <BiXCircle color='red' style={{ fontSize: "250px" }} />


                    <br />
                    <b> عدم دسترسی </b>
                    <br />
                    <br />
                    <b>

                        به منظور تنظیم دسترسی خود با مدیر سیستم تماس بگیرید
                    </b>
                </rsuite.Col>
            </rsuite.Row>


        </Layout >


    )
}

export default AccessDenied;